import { HttpClient } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { NgxMaskModule } from 'ngx-mask';
import { AppRoutingModule } from '../app.routing';
import { NoAuthGuard } from '../auth/no-auth-guard.service';
import { SharedModule } from '../shared';
import { ClientResolver } from './client-resolver.service';
import { SignupComponent } from './signup.component';

export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');  // Path to translation files
}

@NgModule({
  imports: [
    AppRoutingModule,
    NgxMaskModule,
    SharedModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
      }
    }),
  ],
  declarations: [
    SignupComponent
  ],
  providers: [
    NoAuthGuard,
    ClientResolver
  ]
})
export class SignUpModule { }
